module.exports = __webpack_public_path__ + "static/visionar_augemented_reality_augmented-reality-marketing_792-352-1-e7e1041fced53a93d50b654b16edc855.jpg";